<template>
    <div :id="'leaflet--' + element.id"
         class="item pb-3 mb-5 border-bottom">
        <div class="row">
            <div class="col-12">

                <!--            Name -->
                <h2 v-if="element.name" class="col-12">{{ element.name }}</h2>

                <p class="col-12"><i class="fad fa-calendar-week"></i> Gültig: {{ startDate }}
                    {{ endDate }} </p>

                <!--            Description -->
                <div v-if="element.description"
                     class="col-12"
                     v-html="element.description"></div>

                <div v-if="filePath"
                     class="col-12 text-right align-self-end">
                    <a :href="filePath"
                       class="btn btn-outline-secondary btn-sm"
                       target="_blank">
                        Flugblatt herunterladen <i class="fad fa-download"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Leaflet',
    props: {
        item: Object,
    },
    data() {
        return {
            element: this.item,
        };
    },

    computed: {
        startDate() {
            return ' von ' + moment(this.element.valid_from).format('LL');
        },
        endDate() {
            if (this.element.valid_from) {
                return ' bis ' + moment(this.element.valid_to).format('LL');
            }
        },

        filePath() {
            if (this.element.file && this.element.file !== '') {
                return '/storage' + this.element.file;
            }

            return false;
        },
    },
};
</script>
